import { useGetModuleNames } from 'api';
import { FEATURE_FLAGS, useFeatureFlag } from 'feature-flags';

// Planning is always available in local dev so it can be worked on without a LaunchDarkly
// session; everywhere else it is gated by the release flag. Either way it is a Vector Pro
// feature: VectorCore accounts never see it. The module list is read directly rather than
// through useIsVectorCore, which reports a failed lookup the same as "module absent" — here
// the feature must fail closed, staying hidden until the list has actually arrived and
// confirms the account is not VectorCore.
export const useShowPlanning = (): boolean => {
    const releaseActivityPlanning = useFeatureFlag(FEATURE_FLAGS.RELEASE_ACTIVITY_PLANNING);
    const { data: modules } = useGetModuleNames();

    const isConfirmedPro = !!modules && !modules.some((module) => module.toLowerCase() === 'vectorcore');

    if (!isConfirmedPro) {
        return false;
    }

    return process.env.REACT_APP_ENVIRONMENT === 'dev' || releaseActivityPlanning;
};
